var map = {
	"./img.png": "0e02",
	"./logo-large.png": "b22b",
	"./logo-large.svg": "9a09",
	"./logo-small.png": "a441",
	"./logo-small.svg": "bb6e",
	"./pdf.png": "191c",
	"./signature.png": "512f",
	"./sprite.svg": "7e9c",
	"./sprite1.svg": "79f7",
	"./sprite11.svg": "cfdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9d6";